import { render } from "./formListConfig.vue?vue&type=template&id=44a5da44&ts=true"
import script from "./formListConfig.vue?vue&type=script&lang=ts"
export * from "./formListConfig.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__